
if($('#homepage-categories-slider').length > 0){
let categoryComponentSplide = new Splide('#homepage-categories-slider', {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    pagination: false,
    arrows: true,
    breakpoints: {
        640: {
            perPage: 2,
        },
    },
});

categoryComponentSplide.mount();
}

if($('#search-category-slider').length > 0){
    let numberOfCategories = $('.category-col').length;
    let arrows = false;
    if(screen.width <= 640) {
        arrows = numberOfCategories > 2;
    } else {
        arrows = numberOfCategories > 4;
    }

    let searchCategorySplide = new Splide('#search-category-slider', {
        type: numberOfCategories > 4 ? 'loop' : 'slide',
        perPage: 4,
        perMove: 1,
        pagination: false,
        arrows: arrows,
        breakpoints: {
                640: {
                    type: numberOfCategories > 2 ? 'loop' : 'slide',
                    perPage: 2,
                },
            },
    });

    searchCategorySplide.mount();
}

if($('#search-tag-slider').length > 0){
    let numberOfTagss = $('.tag-col').length;
    let arrows = false;
    if(screen.width <= 640) {
        arrows = numberOfTagss > 2;
    } else {
        arrows = numberOfTagss > 4;
    }

    let searchTagSplide = new Splide('#search-tag-slider', {
        type: numberOfTagss > 4 ? 'loop' : 'slide',
        perPage: 4,
        perMove: 1,
        pagination: false,
        arrows: arrows,
        breakpoints: {
                640: {
                    type: numberOfTagss > 2 ? 'loop' : 'slide',
                    perPage: 2,
                },
            },
    });

    searchTagSplide.mount();
}



